import { contractApi } from '../contractApi';
import { FeeSummaryView } from '../types/contractTypes';

const grouperEndpoints = contractApi.injectEndpoints({
  endpoints: (builder) => ({
    // Upload Groupers via CSV file
    uploadGroupers: builder.mutation<FeeSummaryView, { feeScheduleId: string; file: File }>({
      query: ({ feeScheduleId, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `FeeSchedule/${feeScheduleId}/Groupers/Upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { feeScheduleId }) => [
        { type: 'Grouper', id: feeScheduleId },
        { type: 'FeeSchedule', id: feeScheduleId },
        'Grouper',
        'FeeSchedule',
      ],
    }),

    // Download Groupers as CSV file
    downloadGroupers: builder.mutation<Blob, { feeScheduleId: string }>({
      query: ({ feeScheduleId }) => ({
        url: `FeeSchedule/${feeScheduleId}/Groupers/Download`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useUploadGroupersMutation, useDownloadGroupersMutation } = grouperEndpoints;
